import { W as WuiPagination$1, d as defineCustomElement$1 } from './p-Cw1JETmh.js';

const WuiPagination = WuiPagination$1;
const defineCustomElement = defineCustomElement$1;

export { WuiPagination, defineCustomElement };
